module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-page"
  }, [_c('div', {
    staticClass: "content",
    on: {
      "click": function($event) {
        _vm.dropDownOpen = false
      }
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "contact-inner"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "contactform"
  }, [(!_vm.formSubmitted) ? [_c('div', {
    staticClass: "general-form"
  }, [_c('h3', [_vm._v("Reach out to one of The Renees to book a location or with any questions regarding your search")]), _vm._v(" "), _c('form', {
    ref: "generalform",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.formSubmit('generalform')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('textarea', {
    attrs: {
      "name": "message",
      "placeholder": "Enter your message here",
      "tabindex": "5",
      "required": ""
    }
  }), _vm._v(" "), _c('div', {
    ref: "recaptcha",
    staticClass: "recaptcha"
  }), _vm._v(" "), (!_vm.formLoading) ? _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send It")]) : _c('button', {
    attrs: {
      "type": "submit",
      "disabled": "disabled"
    }
  }, [_vm._v("Sending..")])])])] : [_c('h1', {
    staticClass: "received"
  }, [_vm._v("Submission Received")]), _vm._v(" "), _c('p', [_vm._v("Thank you! We'll get back to you as soon as possible.")])]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "bottom-section"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-team first"
  }, [_c('div', {
    staticClass: "contact-card"
  }, [_c('div', {
    staticClass: "details"
  }, [_c('h4', [_vm._v("Renee "), _c('span', [_vm._v("Hambley")])]), _vm._v(" "), _c('h5', [_vm._v("founder")]), _vm._v(" "), _c('p', [_vm._v("\"I love these buildings, growing closer to the people within them has been a bonus.\"")])]), _vm._v(" "), _c('a', {
    staticClass: "email",
    attrs: {
      "href": "mailto:renee@therenees.com"
    }
  }, [_vm._v("renee@therenees.com")])]), _vm._v(" "), _c('div', {
    staticClass: "contact-card"
  }, [_c('img', {
    attrs: {
      "src": "/static/renee.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contact-card headline"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-team second"
  }, [_c('div', {
    staticClass: "contact-card mobileonly"
  }, [_c('img', {
    attrs: {
      "src": "/static/renee.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h4', [_vm._v("Renee "), _c('span', [_vm._v("Hambley")])]), _vm._v(" "), _c('h5', [_vm._v("founder")]), _vm._v(" "), _c('p', [_vm._v("\"I love these buildings, growing closer to the people within them has been a bonus.\"")])]), _vm._v(" "), _c('a', {
    staticClass: "email",
    attrs: {
      "href": "mailto:renee@therenees.com"
    }
  }, [_vm._v("renee@therenees.com")])]), _vm._v(" "), _c('div', {
    staticClass: "contact-card"
  }, [_c('img', {
    attrs: {
      "src": "/static/alexis.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h4', [_vm._v("Alexis "), _c('span')]), _vm._v(" "), _c('h5', [_vm._v("Property Director")]), _vm._v(" "), _c('a', {
    staticClass: "email",
    attrs: {
      "href": "mailto:alexis@therenees.com"
    }
  }, [_vm._v("alexis@therenees.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-card"
  }, [_c('img', {
    attrs: {
      "src": "/static/cristina.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h4', [_vm._v("Cristina "), _c('span')]), _vm._v(" "), _c('h5', [_vm._v("Property Production Assistant")]), _vm._v(" "), _c('a', {
    staticClass: "email",
    attrs: {
      "href": "mailto:cristina@therenees.com"
    }
  }, [_vm._v("cristina@therenees.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-card"
  }, [_c('img', {
    attrs: {
      "src": "/static/ivan.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h4', [_vm._v("Ivan "), _c('span')]), _vm._v(" "), _c('h5', [_vm._v("content director")]), _vm._v(" "), _c('a', {
    staticClass: "email",
    attrs: {
      "href": "mailto:ivan@therenees.com"
    }
  }, [_vm._v("ivan@therenees.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-card"
  }, [_c('img', {
    attrs: {
      "src": "/static/paula2.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h4', [_vm._v("Paula "), _c('span')]), _vm._v(" "), _c('h5', [_vm._v("site rep")]), _vm._v(" "), _c('a', {
    staticClass: "email",
    attrs: {
      "href": "mailto:paula@therenees.com"
    }
  }, [_vm._v("paula@therenees.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-card"
  }, [_c('img', {
    attrs: {
      "src": "/static/raffa.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h4', [_vm._v("Raffa "), _c('span')]), _vm._v(" "), _c('h5', [_vm._v("site rep")]), _vm._v(" "), _c('a', {
    staticClass: "email",
    attrs: {
      "href": "mailto:raffa@therenees.com"
    }
  }, [_vm._v("raffa@therenees.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-card"
  }, [_c('img', {
    attrs: {
      "src": "/static/julie.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h4', [_vm._v("Julie "), _c('span')]), _vm._v(" "), _c('h5', [_vm._v("site rep")]), _vm._v(" "), _c('a', {
    staticClass: "email",
    attrs: {
      "href": "mailto:julie@therenees.com"
    }
  }, [_vm._v("julie@therenees.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-card"
  }, [_c('img', {
    attrs: {
      "src": "/static/headshot-placeholder2.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h4', [_vm._v("Fernand "), _c('span')]), _vm._v(" "), _c('h5', [_vm._v("photographer")]), _vm._v(" "), _c('a', {
    staticClass: "email",
    attrs: {
      "href": "mailto:content@therenees.com"
    }
  }, [_vm._v("content@therenees.com")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contactinfo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon.png")
    }
  }), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Address")]), _vm._v("\n            756 S Broadway"), _c('br'), _vm._v("\n            Suite 709"), _c('br'), _vm._v("\n            Los Angeles, CA 90014\n         ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-left"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "firstname",
      "placeholder": "First Name",
      "tabindex": "1",
      "required": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Email",
      "tabindex": "3",
      "required": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-right"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "lastname",
      "placeholder": "Last Name",
      "tabindex": "2",
      "required": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "phone",
      "placeholder": "Phone",
      "tabindex": "4"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85edcd8c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactPage.vue
// module id = 212
// module chunks = 1